import jwt_decode from "jwt-decode";

export const endSession = () => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/";
};

/**
 * Returns true when a JWT is stored but already expired (or malformed).
 * The API Gateway Cognito authorizer answers expired tokens with a 401 that
 * has no CORS headers, so `fetch`/`axios` never expose that status to JS
 * (it surfaces as "Failed to fetch"). Checking `exp` client-side lets us log
 * the user out reliably instead of showing an "Unknown error".
 */
export const isTokenExpired = () => {
  const token = localStorage.getItem("jwt");
  if (!token) return false;
  try {
    const { exp } = jwt_decode(token);
    if (!exp) return false;
    return exp * 1000 <= Date.now();
  } catch {
    return true;
  }
};

export const getFromSession = (key) => {
  const sessionObject = getSessionObject();
  return sessionObject[key];
};

export const validateSession = () => {
  return getFromSession("jwt") !== null || getFromSession("session") !== null;
};

export const getSessionObject = () => {
  const sessionKey = "session";
  const session =
    localStorage.getItem(sessionKey) || sessionStorage.getItem(sessionKey);
  if (typeof session === "string" && session !== "undefined") {
    return JSON.parse(session);
  }
  return {};
};

export const generatePrimaryKey = () => {
  const { SK } = getSessionObject();
  return SK;
};
